import cx from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

interface Props {
  sm?: boolean;
  noMargin?: boolean;
  noMarginTop?: boolean;
  expandHorizontal?: boolean;
  className?: string;
}

const Separator: React.FC<Props> = ({ sm = false, noMargin = false, noMarginTop = false, expandHorizontal = true, className = '' }) => (
  <div
    className={cx('bg-separator-gray', className, {
      'mb-8': !noMargin,
      'mt-6': !noMarginTop,
      row: expandHorizontal,
      [styles.heightSm]: sm,
      [styles.heightLg]: !sm,
    })}
  />
);

export default Separator;
